/**
 * Creates a Tab component for a widget
 * The Tabs can be personalized with the parameter below.
 *
 * @param   {Array.<Object>}    tabs                    Array of Objects with the tabs, REQUIRED
 * @param   {string}            tabs[].name             > Name of the tab
 * @param   {Function}          tabs[].function         > Function to be call when clicking the tab
 * @param   {string}            tabs[].position         > Position of the tabs: right/left hand side of widget
 * @param   {string}            tabs[].selected         > If the tab is selected or not
 * @param   {boolean}           ownStyles               If the user will apply own styles or not
 *
 */

/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *  Tab class
 *
 * @export
 * @class Tabs
 * @extends {React.Component<any, any>}
 */
export default class Tabs extends React.Component<any, any> {

    constructor(props: any) {
        super(props)
        this.state = {
            tabs: this.props.tabs,
        }
    }

    componentWillMount() {
        if (!this.props.ownStyles) {
            require('./styles/Tabs.css')
        }
    }

    /**
     * Will change the selected tab and will execute the function
     * associated with that tab from the parent
     *
     * @memberof Tabs
     * @param {Object} itemToUpdate the tab the user's clicked
     */
    selectItem = (itemToUpdate, event) => {
        let provItems = this.state.tabs
        this.state.tabs.map((item, index) => {
            if (this.state.tabs[index].name === itemToUpdate.name) {
                provItems[index].selected = true
            } else if (this.state.tabs[index].position === itemToUpdate.position) {
                provItems[index].selected = false
            }
        })
        this.setState({ tabs: provItems })
        itemToUpdate.function(event)
    }

    /**
     * Will generate the tabs passed as an array from the parent
     *
     * @memberof Tabs
     * @param {Array.<Object>} tabs Array of Objects with the tabs to render
     * @returns {ReactDOM} the tabs in the DOM
     */
    generateTabs = (tabs) => {
        return this.state.tabs.map((item, index) => {
            return (
                <div key={'widget-tab-' + index}>
                    <div
                        className={`widget-tabs__switch
                                    ${(item.selected) ? ' selected' : null}
                                    ${item.position}
                        `}
                        onClick={(event) => { this.selectItem(item, event) }}
                    >
                        {item.name}
                    </div>
                </div>
            )
        })
    }

    render() {
        return (
            <div className="widget-tabs">
                {this.generateTabs(this.state.tabs)}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/Tabs/Tabs.tsx